import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import App from './component';
import AppActions from '@common/actions/AppActions';
import { AppSelectors, RouterSelectors, UserSelectors } from '@rental-manager/selectors';
import { logError } from '@zg-rentals/log-error';

const mapStateToProps = (state) => ({
  user: UserSelectors.makeUser(state),
  isMobile: AppSelectors.makeIsScreenMobile(state),
  cookieEnabledServices: AppSelectors.makeCookieEnabledServices(state),
  clusterSettings: AppSelectors.makeclusterSettings(state),
  pathname: RouterSelectors.makePathname(state),
  queryString: RouterSelectors.makeSearch(state),
  brand: AppSelectors.makeBrand(state),
  encodedGuidZuid: AppSelectors.makeEncodedGuidZuid(state),
});

const mapDispatchToProps = (dispatch) => ({
  handleResize: async (width) => {
    try {
      return dispatch(AppActions.screenDimensionChange(width));
    } catch (err) {
      logError({ error: err });
      return { error: true };
    }
  },
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
